const mobileUserAgentPattern = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

export type DeviceType = 'desktop' | 'mobile';

export const getDeviceType = (): DeviceType => {
  if (typeof navigator === 'undefined' || !navigator.userAgent) {
    return 'desktop';
  }
  return mobileUserAgentPattern.test(navigator.userAgent) ? 'mobile' : 'desktop';
};
